import React, { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";
import {
  SportsSoccer,
  Handshake,
  Visibility,
  Instagram,
} from "@mui/icons-material";
import {
  useTheme,
  useMediaQuery,
  Box,
  Container,
  Grid,
  Paper,
  Typography,
  keyframes,
} from "@mui/material";
import StatsSctCard from "./StatsSctCard";
import StatsText from "./StatsTexts";

export default function StatsSct() {
  const sectionRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [hasAnimated, setHasAnimated] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const statsData = [
    {
      label: "Followers",
      value: 54000,
      suffix: "+",
      icon: <Instagram sx={{ fontSize: { xs: 32, sm: 48 } }} />,
      color: "#E4405F",
      bgGradient:
        "linear-gradient(135deg, #f09433 0%, #d62976 50%, #962fbf 100%)",
    },
    {
      label: "Views",
      value: 5000,
      suffix: "+",
      icon: <Visibility sx={{ fontSize: { xs: 32, sm: 48 } }} />,
      color: "#2196F3",
      bgGradient: "linear-gradient(135deg, #2196F3 0%, #21CBF3 100%)",
    },
    {
      label: "مربیان معرفی شده",
      value: 100,
      suffix: "+",
      icon: <Handshake sx={{ fontSize: { xs: 32, sm: 48 } }} />,
      color: "#4CAF50",
      bgGradient: "linear-gradient(135deg, #4CAF50 0%, #8BC34A 100%)",
    },
    {
      label: "باشگاه های معرفی شده",
      value: 150,
      suffix: "+",
      icon: <SportsSoccer sx={{ fontSize: { xs: 32, sm: 48 } }} />,
      color: "#9C27B0",
      bgGradient: "linear-gradient(135deg, #9C27B0 0%, #E040FB 100%)",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
        }
      },
      { threshold: 0.3 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasAnimated]);

  const items = statsData.map((stat, index) => (
    <StatsSctCard
      stat={stat}
      index={index}
      key={index}
      hoveredIndex={hoveredIndex}
      setHoveredIndex={setHoveredIndex}
      hasAnimated={hasAnimated}
    />
  ));

  return (
    <Box
      ref={sectionRef}
      sx={{
        py: "2rem",
        pt: "4rem",

        position: "relative",
        overflow: "hidden",
        bgcolor: "custom.contrast",
      }}
    >
      <Container maxWidth="xxl">
        <Grid container>{items}</Grid>

        <StatsText />
      </Container>
    </Box>
  );
}
